import { apiClient } from './apiClient';
import { API_CONFIG } from '../config/api';
import { logError, logInfo } from './logtail';

export interface PromoCodeResponse {
  success: boolean;
  errorMessage?: string;
  message?: string;
  premiumUntil?: string;
}

export const redeemPromoCode = async (code: string): Promise<PromoCodeResponse> => {
  try {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.PROMOCODE_REDEEM, {
      code
    });
    logInfo('Redeemed promo code', { code });
    return response.data;
  } catch (error) {
    logError('Failed to redeem promo code', { code, error });
    throw error;
  }
};
